/**
 * Status Badge Component
 * Displays community profile status with color coding
 */

import { Badge } from '@/core/components/ui/badge';

interface StatusBadgeProps {
  status: string; // "Deleted" | "Active" (API returns enum as string)
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const variants = {
    Deleted: { label: 'Deleted', className: 'bg-gray-100 text-gray-800' },
    Active: { label: 'Active', className: 'bg-green-100 text-green-800' },
  };

  const config = variants[status as keyof typeof variants] || variants.Deleted;

  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
